/* Search section click actions listener */
document.addEventListener('click', (event) => {
  const clickEventPath = event.composedPath().slice(0, -2);

  for (const element of clickEventPath) {
    const clickAction = element?.getAttribute('data-action');

    if (clickAction === 'open-search-drawer') openSearchDrawerHandler();
    else if (clickAction === 'close-search-drawer') closeSearchDrawerHandler();
    else if (clickAction === 'show-product-results')
      showProductResultsHandler(element);
    else if (clickAction === 'show-article-results')
      showArticleResultsHandler(element);
    else if (clickAction === 'show-previous-product')
      showPreviousProductHandler();
    else if (clickAction === 'show-next-product') showNextProductHandler();
    else if (clickAction === 'show-previous-article')
      showPreviousArticleHandler();
    else if (clickAction === 'show-next-article') showNextArticleHandler();
  }
});

/* Escape key close search drawer handler */
document.addEventListener('keydown', (event) => {
  console.log(event.key, event);
  if (event.key === 'Escape') closeSearchDrawerHandler();
});

/* Search drawer open handler */
function openSearchDrawerHandler() {
  const searchDrawer = document.querySelector('.mx-recherche-panda');
  document.documentElement.setAttribute('data-locked', '');
  searchDrawer.setAttribute('data-active', '');
  document.body.classList.add('overflow-hidden-search');
}

/* Search drawer close handler */
function closeSearchDrawerHandler() {
  const searchDrawer = document.querySelector('.mx-recherche-panda');
  document.documentElement.removeAttribute('data-locked');
  searchDrawer.removeAttribute('data-active');
  document.body.classList.remove('overflow-hidden-search');
}

/* Show product results handler */
function showProductResultsHandler(tabTitle) {
  if (tabTitle.hasAttribute('data-active')) return false;

  const tabTitles = Array.from(tabTitle.parentElement.children);

  tabTitles.forEach((title) => {
    title === tabTitle
      ? title.setAttribute('data-active', '')
      : title.removeAttribute('data-active');
  });

  const searchResultWrappers = document.querySelectorAll(
    '.mx-recherche-panda .search-results-wrapper'
  );

  searchResultWrappers.forEach((wrapper) => {
    wrapper.hasAttribute('data-products')
      ? wrapper.setAttribute('data-active', '')
      : wrapper.removeAttribute('data-active');
  });
}

/* Show article results handler */
function showArticleResultsHandler(tabTitle) {
  if (tabTitle.hasAttribute('data-active')) return false;

  const tabTitles = Array.from(tabTitle.parentElement.children);

  tabTitles.forEach((title) => {
    title === tabTitle
      ? title.setAttribute('data-active', '')
      : title.removeAttribute('data-active');
  });

  const searchResultWrappers = document.querySelectorAll(
    '.mx-recherche-panda .search-results-wrapper'
  );

  searchResultWrappers.forEach((wrapper) => {
    wrapper.hasAttribute('data-articles')
      ? wrapper.setAttribute('data-active', '')
      : wrapper.removeAttribute('data-active');
  });
}

/* Search section change actions listener */
const searchQueryInput = document.querySelector('[data-action="search-query"]');
const debounceSearchQueryHandler = debounce(searchQueryHandler, 800);

searchQueryInput.addEventListener('input', debounceSearchQueryHandler);

async function searchQueryHandler() {

  document.querySelectorAll('#shopify-section-search-panda .search-results-container').forEach((elem) => {
    elem.classList.add('loading')
  })

  setTimeout(() => {
    document.querySelectorAll('#shopify-section-search-panda .search-results-container').forEach((elem) => {
      elem.classList.remove('loading')
    })
  }, 5000);

  document.querySelectorAll('.search-global-results-container .error__container').forEach((container) => {
    container.classList.add('hidden');
  });

  const searchQuery = searchQueryInput.value;

  if (searchQuery.length === 0) {
    resetProductResults();
    resetArticleResults();
    return false;
  }

  const queryParameters = `q=${searchQuery}&resources[type]=product,article&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,body&section_id=search-panda`;

  const searchResultsMarkup = await fetch(`/search/suggest?${queryParameters}`)
    .then((response) => {
      requestResponse = response;
      return response.text();
    })
    .then((text) => {
      if (!requestResponse.ok) {
        throw new Error(`${requestResponse.status}: ${text}`);
      }

      const requestMarkup = new DOMParser().parseFromString(text, 'text/html');

      return requestMarkup;
    });

  const productCount = parseInt(
    searchResultsMarkup
      .querySelector('[data-product-count]')
      .getAttribute('data-product-count')
  );
  const articleCount = parseInt(
    searchResultsMarkup
      .querySelector('[data-article-count]')
      .getAttribute('data-article-count')
  );

  if (productCount > 0) {
    const productResultsMarkup = searchResultsMarkup.querySelector(
      '[data-products] .search-results'
    );
    displayProductResults(productResultsMarkup, productCount);
  } else {
    resetProductResults();
  }

  if (articleCount > 0) {
    const articleResultsMarkup = searchResultsMarkup.querySelector(
      '[data-articles] .search-results'
    );
    displayArticleResults(articleResultsMarkup, articleCount);
  } else {
    resetArticleResults();
  }

  document.querySelectorAll('#shopify-section-search-panda .search-results-container').forEach((elem) => {
    elem.classList.remove('loading')
  })

  /* Query term report test */
  const searchHttpCall = await fetch(`/search?${queryParameters}`);
}

function displayProductResults(productResultsMarkup, productCount) {
  const productResultsContainer = document.querySelector(
    '.mx-recherche-panda .search-results-wrapper[data-products] .search-results-container'
  );
  productResultsContainer.querySelector('.search-results').innerHTML =
    productResultsMarkup.innerHTML;
  productResultsContainer.setAttribute('data-active', 'search');
  productResultsContainer.setAttribute('data-product-count', productCount);
}

function resetProductResults() {
  const productListContainer = document.querySelector(
    '.mx-recherche-panda .search-results-wrapper[data-products] .search-results-container'
  );
  const mainContainer = document.querySelector(
    '.search-global-results-container [data-products] .error__container'
  );

  productListContainer.setAttribute('data-active', 'default');
  productListContainer.setAttribute('data-product-count', 0);
  productListContainer.querySelector('.search-results').innerHTML = '';
  document.querySelector('#shopify-section-search-panda .search-bar-container').classList.remove('loading');

  mainContainer.classList.remove('hidden');
}

function displayArticleResults(articleResultsMarkup, articleCount) {
  const articleResultsContainer = document.querySelector(
    '.mx-recherche-panda .search-results-wrapper[data-articles] .search-results-container'
  );

  articleResultsContainer.querySelector('.search-results').innerHTML =
    articleResultsMarkup.innerHTML;
  articleResultsContainer.setAttribute('data-active', 'search');
  articleResultsContainer.setAttribute('data-article-count', articleCount);
}

function resetArticleResults() {
  const articleListContainer = document.querySelector(
    '.mx-recherche-panda .search-results-wrapper[data-articles] .search-results-container'
  );

  const mainContainer = document.querySelector(
    '.search-global-results-container [data-articles] .error__container'
  );

  articleListContainer.setAttribute('data-active', 'default');
  articleListContainer.setAttribute('data-article-count', 0);
  articleListContainer.querySelector('.search-results').innerHTML = '';
  document.querySelector('#shopify-section-search-panda .search-bar-container').classList.remove('loading');

  mainContainer.classList.remove('hidden');
}

function showPreviousProductHandler() {
  const productListContainer = document.querySelector(
    '.mx-recherche-panda .search-results-wrapper[data-products] .search-results-container'
  );
  const activeProductList =
    productListContainer.getAttribute('data-active') === 'search'
      ? productListContainer.querySelector('.search-results')
      : productListContainer.querySelector('.default-search-results');

  scrollToSlide(activeProductList, 'previous');
}

function showNextProductHandler() {
  const productListContainer = document.querySelector(
    '.mx-recherche-panda .search-results-wrapper[data-products] .search-results-container'
  );
  const activeProductList =
    productListContainer.getAttribute('data-active') === 'search'
      ? productListContainer.querySelector('.search-results')
      : productListContainer.querySelector('.default-search-results');

  scrollToSlide(activeProductList, 'next');
}

function showPreviousArticleHandler() {
  const articleListContainer = document.querySelector(
    '.mx-recherche-panda .search-results-wrapper[data-articles] .search-results-container'
  );
  const activeArticleList =
    articleListContainer.getAttribute('data-active') === 'search'
      ? articleListContainer.querySelector('.search-results')
      : articleListContainer.querySelector('.default-search-results');

  scrollToSlide(activeArticleList, 'previous');
}

function showNextArticleHandler() {
  const articleListContainer = document.querySelector(
    '.mx-recherche-panda .search-results-wrapper[data-articles] .search-results-container'
  );
  const activeArticleList =
    articleListContainer.getAttribute('data-active') === 'search'
      ? articleListContainer.querySelector('.search-results')
      : articleListContainer.querySelector('.default-search-results');

  scrollToSlide(activeArticleList, 'next');
}

function scrollToSlide(slider, command) {
  const items = slider.children;
  const numberOfItems = items.length;
  const itemWidth = items[0].offsetWidth;
  const sliderGap = parseInt(window.getComputedStyle(slider).rowGap);
  const numberOfItemsOnScreen = Math.round(
    slider.offsetWidth / (itemWidth + sliderGap)
  );
  const sliderScrollOffset = slider.scrollLeft;
  const activeItemIndex = Math.round(
    sliderScrollOffset / (itemWidth + sliderGap)
  );
  let nextItemIndex;

  switch (command) {
    case 'previous':
      nextItemIndex = activeItemIndex - 1;
      if (nextItemIndex < 0) {
        nextItemIndex = numberOfItems - numberOfItemsOnScreen;
      }
      break;
    case 'next':
      nextItemIndex = activeItemIndex + 1;
      if (nextItemIndex > numberOfItems - numberOfItemsOnScreen) {
        nextItemIndex = 0;
      }
      break;
    default:
      nextItemIndex = Math.floor(sliderScrollOffset / (itemWidth + sliderGap));
  }

  const nextSliderOffset = nextItemIndex * (itemWidth + sliderGap);

  slider.scroll({ left: nextSliderOffset, behavior: 'smooth' });
}

function debounce(func, delay) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, arguments);
    }, delay);
  };
}

//  click outside to close search drawer 

document.addEventListener('click', function (event) {
  var searchDrawer = document.querySelector('.mx-recherche-panda');
  var sideDrawer = document.querySelector('quick-add-drawer');
  console.log(event.target);

  if (!searchDrawer.contains(event.target) && !event.target.matches('[data-action="open-search-drawer"]') && !sideDrawer.contains(event.target)) {
    document.documentElement.removeAttribute('data-locked');
    searchDrawer.removeAttribute('data-active');
    document.body.classList.remove('overflow-hidden-search');
  }
}
);